<template>
  <div class="footer"><router-link to="/"> Home </router-link></div>
</template>

<style scoped>
.footer {
  padding: 20px 0;
}
</style>

